export default __webpack_public_path__ + "static/media/login_img.c50e9137.png";